import React from 'react';
import Icon from '../../../components/AppIcon';

const ValuesSection = () => {
  const values = [
    {
      icon: "Award",
      title: "Leadership Excellence",
      description: "Developing confident, capable leaders who can make a positive difference in their communities and professional lives through hands-on experience.",
      color: "text-primary",
      bgColor: "bg-primary/10"
    },
    {
      icon: "Heart",
      title: "Purposeful Service",
      description: "Every project addresses real community needs with measurable impact, ensuring our service creates lasting positive change for those we serve.",
      color: "text-secondary",
      bgColor: "bg-secondary/10"
    },
    {
      icon: "Users",
      title: "Unity & Fellowship",
      description: "Building strong bonds among members while fostering collaboration, mutual support, and lifelong friendships that extend beyond our club.",
      color: "text-accent",
      bgColor: "bg-accent/10"
    },
    {
      icon: "TrendingUp",
      title: "Continuous Growth",
      description: "Commitment to personal and collective improvement, embracing innovation and learning to enhance our service capabilities and leadership skills.",
      color: "text-purple-600",
      bgColor: "bg-purple-100"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-foreground mb-6">
            Our Core
            <span className="text-primary"> Values</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Rooted in the principles of Leoism, these values have guided us for over three decades, 
            shaping leaders and creating positive change in communities across Sri Lanka.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className="group relative bg-surface rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="space-y-6">
                <div className={`w-16 h-16 ${value.bgColor} rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                  <Icon name={value.icon} size={32} className={value.color} />
                </div>
                
                <div>
                  <h3 className="text-xl font-bold text-foreground mb-3 group-hover:text-primary transition-colors duration-300">
                    {value.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">
                    {value.description}
                  </p>
                </div>
              </div>
              
              <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </div>
          ))}
        </div>

        {/* Leo Motto & Mission */}
        <div className="mt-20 bg-gradient-to-r from-primary to-secondary rounded-3xl p-12 text-white text-center">
          <div className="max-w-4xl mx-auto space-y-8">
            <h3 className="text-4xl font-bold">The Spirit of Leoism</h3>
            <div className="text-2xl font-semibold text-white/95 italic">
              "Leadership • Experience • Opportunity"
            </div>
            <p className="text-xl text-white/90 leading-relaxed">
              For over 33 years, we've embodied the true spirit of Leoism - providing leadership opportunities, 
              creating meaningful experiences, and opening doors for young people to make a difference. 
              Our values aren't just principles; they're the foundation of every life we've touched and every leader we've developed.
            </p>
            
            {/* <div className="grid md:grid-cols-3 gap-8 mt-12">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <div className="text-3xl font-bold mb-2">500+</div>
                <div className="text-white/90">Lives Impacted Through Service</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <div className="text-3xl font-bold mb-2">100+</div>
                <div className="text-white/90">Leaders Developed</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <div className="text-3xl font-bold mb-2">33</div>
                <div className="text-white/90">Years of Excellence</div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;